// ▶ beside a Sound picker — hear it before choosing it. Plays the sound that
// would ACTUALLY be used (the caller resolves "Sensor's sound" / "By type" to a
// real one), so a blank picker still previews something truthful.
//
// Desktop dev server only (core/push/soundPreview); renders nothing elsewhere.

import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { canPreviewSounds, playSound } from '../../core/push/soundPreview';
import { SOUNDS } from '../../core/push/pushChannels';

const nameOf = (s) => (SOUNDS.find((x) => x.sound === s) || {}).name || s;

export default function SoundPlayButton({ sound, sx }) {
  const [error, setError] = useState('');
  if (!canPreviewSounds()) return null;
  return (
    <Tooltip title={error || `Play “${nameOf(sound)}”`}>
      <IconButton
        size="small"
        sx={sx}
        onClick={async () => {
          const r = await playSound(sound);
          setError(r.ok ? '' : r.error);
        }}
      >
        <PlayCircleOutlineIcon fontSize="small" color={error ? 'warning' : 'inherit'} />
      </IconButton>
    </Tooltip>
  );
}
